import styled from 'styled-components'
import { PropsWithChildren } from 'react'

import theme from '../../theme'

type WrapperProps = {
  $padding?: number
}

const Wrapper = styled.div<{ $padding?: number }>`
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
  padding: ${(props: WrapperProps) => (props.$padding ? `0px ${props.$padding}px` : '0px')};
  box-sizing: border-box;

  &.use-scroll {
    height: 100%;
    overflow-y: scroll;
  }

  /* css */
  @media screen and (max-width: ${theme.width.mobile.large}px) {
    padding: 0px;
  }
`

type Props = {
  padding?: number
  scroll?: boolean
}

const Content: React.FC<PropsWithChildren<Props>> = (props: PropsWithChildren<Props>) => {
  return (
    <Wrapper className={props.scroll ? 'use-scroll' : ''} $padding={props.padding}>
      {props.children}
    </Wrapper>
  )
}

export default Content
